import { TbFileInvoice } from 'react-icons/tb'

import { dictionaryCodeFormTemplate } from '../Components/DictionaryCodeHint'
import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { STATUS_LIST_COLUMNS, STATUS_LIST_FILTERS, statusListFields } from '../Contracts/StatusListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Статуси заявок» (сім'я `StatusList`, `SPEC-007` §4).
 *
 * Етапи заявки (етап 2). `sorting` системних статусів задає порядок процесу (RK-08).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListApplicationStatusResource: IResourceConfig = {
    title: 'Статуси заявок',
    fields: statusListFields(),
    table: {
        showColumns: STATUS_LIST_COLUMNS,
    },
    filter: {
        includeFields: STATUS_LIST_FILTERS,
    },
    // Підказка про код — у формі, над полем «Код» (`SPEC-007` §12)
    form: {
        template: dictionaryCodeFormTemplate,
    },
    places: {
        top: <TopMenu current="application-statuses" />,
    },
    restUrl: '/services/application_statuses',
    pageUrl: '/settings/application-statuses',
    pageConfig: {
        title: 'Статуси заявок',
        icon: <TbFileInvoice />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
